import React from "react";
import "../style/TradingServers.css";

const TradingServers = ({ label, value, max }) => {
  return (
    <div className="trading-servers-container">
        <div className="trade-head">
            <h1>TradingServers</h1>
            <p> Gain a technological edge with Extredes</p>
        </div>

        <section className="funding-secure">
        <h2>Our Trading Servers</h2>
        <p>Extrede  are recognised as a technological industry leader, and as such our live trading servers are now located in the major financial hubs of both London and New York.</p>
        <p>With further ongoing enhancements to the Extrede trading network of servers and data centres, including updates to both hardware and physical locations, Extrede’s industry position can only go from strength to strength.</p>
        <p>All clients of Extrede will benefit from the super-fast and most importantly, stable trading conditions that this server combination offers. Experience the technological difference at Extrede today!</p>
      </section>

      <br/><br/>
      <div id="regimg1" className="imgtext">

      
        

<div  id="text" className="text">
  {/* <p id="p">You are safe with us.</p> */}
  
  <h1  className="h1">Revolutionising Trading Speeds with Equinix Partnership
  </h1 >
  <p>A strategic partnership with Equinix provides Extrede with a fibre optic network solution which connects our trading servers worldwide.</p>
  <p>This guarantees lightning fast execution on every trade. Our partnership with Equinix, the world leader in trading server technology, gives Extrede a technical edge over the competition.</p>
  {/* <h1 className="h1">PCI DSS compliance</h1>
  <p>We're fully audited, adhering to all PCI DSS needs, ensuring card data security through effective management, custom security settings, and regular vulnerability scans</p> */}



<div className="color-progress-container">
    <div className="colortext">
        <div className="colortext1">
            <p>Security guard</p>
        </div>
        <div className="colortext2">
            <p>95</p>
        </div>
    </div>
      <div className="color-progress-label">
        <span>{label}</span>
        <span>{value}</span>
      </div>
      <div className="color-progress-bar">
        <div
          className="color-progress-fill"
          style={{ width: `${(value / max) * 100}%` }}
        ></div>
      </div>
    </div>

    <br/><br/>




  </div>

  <div className="img1">
  <img src="/images/server.png" alt="girl"/>
    </div>

  </div>


  <br/><br/><br/><br/>



  <div id="regimg1" className="imgtext"> 
  <div className="img1">
  <img src="/images/server2.png" alt="girl"/>
    </div>

<div  id="text" className="text">
  {/* <p id="p">You are safe with us.</p> */}
  
  <h1  className="h1">Redefined Speed & Precision: Oslo Capital's oneZero™ MT4 Bridge
  </h1 >
  <p>Extrede is a leader in implementing new technologies for the benefit of our clients.</p>
  <p>The oneZero™ MT4 Bridge is a true next-gen price aggregator, which connects our dark liquidity pool to the client’s MT4 platform.</p>
  <p>The oneZero™ MT4 Bridge is the only technologically advanced solution which is able to handle the execution of large numbers of market orders at incredibly high speeds.</p>


<div className="color-progress-container">
    <div className="colortext">
        <div className="colortext1">
            <p>High Speed</p>
        </div>
        <div className="colortext2">
            <p>97</p>
        </div>
    </div>
      <div className="color-progress-label">
        <span>{label}</span>
        <span>{value}</span>
      </div>
      <div className="color-progress-bar">
        <div
          className="color-progress-fill"
          style={{ width: `${(value / max) * 100}%` }}
        ></div>
      </div>
    </div>

  </div>

  </div>

  <br/><br/><br/><br/>








  <div id="regimg1" className="imgtext">

      
        

<div  id="text" className="text">
  {/* <p id="p">You are safe with us.</p> */}
  
  <h1  className="h1">Experience Unrivalled Performance with Oslo Fibre Optic Network
  </h1 >
  <p>The Oslo fibre optic network offers unrivalled performance for all clients.</p>
  <p>We have carefully tested every single fibre optic line connecting our servers to make sure that latency is minimized. This ensures the fastest execution speeds are delivered across the network to our clients. Accelerate performance, realise new possibilities and ignite execution speed, to find your edge via the Oslo fibre optic network.</p>


<div className="color-progress-container">
    <div className="colortext">
        <div className="colortext1">
            <p>Execution speeds</p>
        </div>
        <div className="colortext2">
            <p>91</p>
        </div>
    </div>
      <div className="color-progress-label">
        <span>{label}</span>
        <span>{value}</span>
      </div>
      <div className="color-progress-bar">
        <div
          className="color-progress-fill"
          style={{ width: `${(value / max) * 100}%` }}
        ></div>
      </div>
    </div>

    <br/><br/>


  </div>

  <div className="img1">
  <img src="/images/sever3.png" alt="girl"/>
    </div>

  </div>
  <br/><br/><br/><br/>



  <div id="regimg1" className="imgtext">
  <div className="img1">
  <img src="/images/server2.png" alt="girl"/>
    </div>

      
        

<div  id="text" className="text">
  {/* <p id="p">You are safe with us.</p> */}
  
  <h1  className="h1">Rapid Market Prices Access, Powered by Xeon® E7 & Equinix Fibre Optic
  </h1 >
  <p>We run mission-critical workloads on Equinix fibre optic infrastructure which is designed for 99.99% uptime.
  The brute processing power provided by the Intel Xeon® E7 keeps the oneZero® MT4 Bridge running at the highest speed possible. This allows clients the fastest access to global market prices.</p>
  <br/><br/>
<div className="color-progress-container">
    <div className="colortext">
        <div className="colortext1">
            <p>Higher Speed Ever</p>
        </div>
        <div className="colortext2">
            <p>99</p>
        </div>
    </div>
      <div className="color-progress-label">
        <span>{label}</span>
        <span>{value}</span>
      </div>
      <div className="color-progress-bar">
        <div
          className="color-progress-fill"
          style={{ width: `${(value / max) * 100}%` }}
        ></div>
      </div>
    </div>




  </div>

  

  </div>
  <br/><br/><br/><br/>


  <div className="trade-map">
    <h2>Oslo Global Fibre Optic Server Network</h2>
    <div className="img1">
         <img id="map" src="/images/map.png" alt="girl"/>
    </div>

    <div id="trade-white" className="bg-white py-10 px-4 md:px-20 text-center">
      <h2 className="text-3xl font-bold text-indigo-600 mb-6">
        Start Your Trading Portfolio.
      </h2>
      <div id="new" className="flex flex-col md:flex-row items-center justify-between space-y-8 md:space-y-0">
        {/* Steps Section */}
        <div className="text-left space-y-6 max-w-lg">
          <div className="flex items-start space-x-4">
            {/* <span className="w-8 h-8 bg-indigo-600 text-white rounded-full flex items-center justify-center font-bold">
              1
            </span> */}
            <div>
              <h3 className="text-xl font-semibold">1   Register</h3>
              <p>
                Signup for an Extrede Capitals account and get access to world-class
                pricing.
              </p>
              <button id="open" className="mt-2 px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700">
                Open Account →
              </button>
            </div>
          </div>
          <div className="flex items-start space-x-4">
            {/* <span className="w-8 h-8 bg-indigo-600 text-white rounded-full flex items-center justify-center font-bold">
              2
            </span> */}
            <div>
              <h3 className="text-xl font-semibold">2 Verify your identity</h3>
              <p>
                Complete the identity verification process to secure your account
                and transactions.
              </p>
            </div>
          </div>
          <div className="flex items-start space-x-4">
            {/* <span className="w-8 h-8 bg-indigo-600 text-white rounded-full flex items-center justify-center font-bold">
              3
            </span> */}
            <div>
              <h3 className="text-xl font-semibold">3 Start trading</h3>
              <p>
                You’re good to go! Trade 300+ markets across forex, crypto,
                stocks, commodities.
              </p>
            </div>
          </div>
        </div>

        {/* Mobile Preview */}
        <div>
          <img id="img"
            src="/images/mobile.jpg"
            alt="Mobile Trading Preview"
            className="w-64 md:w-80 shadow-lg rounded"
          />
        </div>
      </div>
      </div>
  </div>


  

        
    </div>
  );
};

export default TradingServers;
